module.exports = __webpack_public_path__ + "static/media/cat_avatar.b752e1ec.svg";